import { useState } from 'react';
import type { CancelScheduledUpcomingPaymentResponse } from 'vopay';
import { api } from '@/services/api.config';

/**
 * Cancels a single remaining payment of a VIOScheduledPayments schedule.
 *
 * Legacy schedules cancel a payment by editing its amount to 0 through the EFT
 * routes, which only match EFT funding and withdrawal transaction types. This
 * endpoint keys off the payment's own detail row and works on any rail.
 */
export default function useCancelUpcomingPayment() {
  const [cancelling, setCancelling] = useState(false);

  async function cancelUpcomingPayment(
    scheduledPaymentDetailsId: string,
  ): Promise<CancelScheduledUpcomingPaymentResponse> {
    try {
      setCancelling(true);

      const res = await api.cancelScheduledUpcomingPayment({
        ScheduledPaymentDetailsID: scheduledPaymentDetailsId,
      });

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error('Cancel upcoming payment failed:', error);
      throw error;
    } finally {
      setCancelling(false);
    }
  }

  return { cancelling, cancelUpcomingPayment };
}
